/* eslint-disable require-jsdoc */
import {createStore, applyMiddleware, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';

import reducers from '../reactModules/redux/reducers/combinedReducers';

const configureStore = (initialState = {}) => {
  const enhancers = [applyMiddleware(thunkMiddleware)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose
  const composeEnhancers =
    (typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

  const store = createStore(
    reducers,
    initialState,
    composeEnhancers(...enhancers)
  );

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/appModules/configureStore.js